module.exports = require("@mui/material/AccordionDetails");